import type { Agent } from "@/lib/qa-types";

export function AgentsView({ agents }: { agents: Agent[] }) {
    const totalCapacity = agents.reduce((total, agent) => total + agent.capacity, 0);
    const activeRuns = agents.reduce((total, agent) => total + agent.active_runs, 0);
    const utilization = totalCapacity === 0 ? 0 : Math.round((activeRuns / totalCapacity) * 100);

    return (
        <section className="workspace-view">
            <div className="view-heading">
                <div>
                    <p className="eyebrow">AGENT RESOURCE POOL</p>
                    <h1>执行节点与容量</h1>
                    <p>按浏览器、系统、网络区域与项目标签匹配隔离执行资源。</p>
                </div>
                <button className="button primary">注册 Agent</button>
            </div>
            <div className="agent-summary">
                <div>
                    <strong>{totalCapacity}</strong>
                    <span>总并发容量</span>
                </div>
                <div>
                    <strong>{activeRuns}</strong>
                    <span>运行中容器</span>
                </div>
                <div>
                    <strong>{utilization}%</strong>
                    <span>资源利用率</span>
                </div>
                <div>
                    <strong>{agents.length}</strong>
                    <span>Agent 总数</span>
                </div>
            </div>
            <div className="agent-grid">
                {agents.map((agent) => (
                    <article className="card agent-card" key={agent.agent_id}>
                        <div className="agent-head">
                            <div className="agent-machine">A</div>
                            <span className={`status-pill ${agent.status.toLowerCase()}`}>{agent.status}</span>
                        </div>
                        <h2>{agent.name}</h2>
                        <p>{agent.agent_id}</p>
                        <div className="label-row">
                            {agent.labels.map((label) => (
                                <span key={label}>{label}</span>
                            ))}
                        </div>
                        <div className="capacity">
                            <div>
                                <span>容器占用</span>
                                <strong>
                                    {agent.active_runs}/{agent.capacity}
                                </strong>
                            </div>
                            <div className="capacity-track">
                                <i style={{ width: `${(agent.active_runs / agent.capacity) * 100}%` }} />
                            </div>
                        </div>
                        <footer>
                            <span>● {agent.last_heartbeat_at}</span>
                            <button>管理节点 →</button>
                        </footer>
                    </article>
                ))}
            </div>
        </section>
    );
}
